export default "/images/contest-slide1.jpg?329fadb27a77b9ee7a99d1617581dbd2";